import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WorkerEndReasonsListComponent } from './worker-end-reasons-list/worker-end-reasons-list.component';
import { WorkerEndReasonsDetailComponent } from './worker-end-reasons-detail/worker-end-reasons-detail.component';

const routes: Routes = [
    {
        path: 'workerEndReasons',
        children: [
            { path: '', component: WorkerEndReasonsListComponent }
        ]
    },
    {
        path: 'workerEndReasons/:id',
        children: [
            { path: '', component: WorkerEndReasonsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],

    exports: [RouterModule]
})
export class WorkerEndReasonsRoutingModule { }
